import { cn } from '@/utils';
import styles from './Badge.module.css';

type BadgeDensity = 'default' | 'compact';

interface BadgeProps {
  value: string;
  backgroundColor?: string;
  textColor?: string;
  ballColor?: string;
  showBall?: boolean;
  density?: BadgeDensity;
}

const Badge = ({
  value,
  backgroundColor,
  textColor,
  ballColor,
  showBall = true,
  density = 'default',
}: BadgeProps) => {
  return (
    <div
      className={cn(
        styles.square,
        density === 'compact' && styles.squareCompact
      )}
      style={{
        color: textColor || ballColor,
        backgroundColor,
        textAlign: 'center',
      }}
    >
      {showBall && (
        <div
          className={styles.roundedBall}
          style={{
            backgroundColor: ballColor,
          }}
        ></div>
      )}
      {value}
    </div>
  );
};

export default Badge;
